import React, { Component } from "react"
import PropTypes from "prop-types"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import * as actions from "./redux/actions"

export class LogoutLink extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  }

  render() {
    return (
      <a className="auth-logout-link" href="" onClick={this.props.actions.logout}>
        {this.props.children}
      </a>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    auth: state.auth,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LogoutLink)



// WEBPACK FOOTER //
// ./src/features/auth/LogoutLink.js